import { GridRenderCellParams } from '@mui/x-data-grid-premium';
import dayjs from 'dayjs';
import DataGridCell from './DataGridCell';

export function baseCell<T>(params: GridRenderCellParams<T>) {
  const value = params.value;
  let safeContent = '';

  if (value instanceof Date) {
    // Se è un oggetto Date nativo, lo formatti al volo
    safeContent = dayjs(value).isValid() ? dayjs(value).format('DD/MM/YYYY') : '';
  } else if (typeof value === 'object' && value !== null) {
    // Se è un oggetto complesso (es. supplier o warehouse) estrai una proprietà di fallback
    // o convertilo in stringa per evitare il crash totale di React
    safeContent = (value as any).name || (value as any).code || (value as any).description || '';
  } else {
    // Se è una stringa, numero o booleano, lo converti in stringa in sicurezza
    safeContent = value != null ? String(value) : '';
  }

  return <DataGridCell content={safeContent} />;
}
